module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 63
// module chunks = 0 1 2 3 4 5 6 7 8 9 10